import {SafeHTMLBox, type SafeHTMLString} from '@github-ui/safe-html'
import {Spinner} from '@primer/react'

import {useLoadRichDiffData} from '../../hooks/use-load-rich-diff-data'

export function RichDiff({
  commitOid,
  path,
  proseDiffHtml,
}: {
  commitOid: string
  path: string
  proseDiffHtml: SafeHTMLString | undefined
}) {
  const {loaded, richDiffData} = useLoadRichDiffData(commitOid, {proseDiffHtml}, path)

  if (!loaded) {
    return (
      <div className="d-flex flex-justify-center p-4">
        <Spinner size="large" />
      </div>
    )
  }

  if (richDiffData.proseDiffHtml) {
    return (
      <div className="prose-diff position-relative">
        <SafeHTMLBox html={richDiffData.proseDiffHtml} />
      </div>
    )
  } else {
    return <div className="d-flex flex-justify-center p-4">This rich diff is not supported at the moment.</div>
  }
}

try{ RichDiff.displayName ||= 'RichDiff' } catch {}